import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DialogActions from '@material-ui/core/DialogActions'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogContentText from '@material-ui/core/DialogContentText'
import { withStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import MuiDialog from '@material-ui/core/Dialog'
import styled from 'styled-components'

const ProgressStyle = styled.div`
  .circle {
    margin-left: 36%;
    margin-bottom: 16px;
  }
`

const Dialog = withStyles(() => ({
  paper: {
    'max-width': '620px',
  },
}))(MuiDialog)

const DialogContent = withStyles(() => ({
  root: {
    paddingBottom: 0,
  },
}))(MuiDialogContent)

const DialogContentText = withStyles(theme => ({
  root: {
    color: theme.black38,
    fontSize: '16px',
  },
}))(MuiDialogContentText)

export default function Progress({
  isOpen,
  abortClick,
  progressText,
  showDialog,
  dialogContent,
}) {
  const [progressClosed, setProgressClosed] = useState(false)
  return (
    <>
      <Dialog open={isOpen} onExit={() => setProgressClosed(true)}>
        <ProgressStyle>
          <DialogContent>
            <CircularProgress color="primary" size={50} className="circle" />
            <DialogContentText>{progressText}</DialogContentText>
          </DialogContent>
          {abortClick ? (
            <DialogActions>
              <Button color="primary" onClick={() => abortClick()}>
                PRZERWIJ
              </Button>
            </DialogActions>
          ) : null}
        </ProgressStyle>
      </Dialog>
      {showDialog && progressClosed && (
        <Dialog open={true}>
          {dialogContent}
          <DialogActions>
            <Button color="primary" onClick={() => setProgressClosed(false)}>
              ZAMKNIJ
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}
